import { SelectItem } from 'primeng/api';
import { FilterSearchingBaseViewModel, PagingResultsViewModel } from '../core/_infrastructure/types/common';

export class FilterSearchingContenidoGes extends FilterSearchingBaseViewModel {
    public textoFiltro? = '';
    public idTipoContenido?: number | null;
    public esAnonimo = true;
    public esAdmin = false;
    public fechaInicio?: Date | null;
    public fechaFin?: Date | null;
    public periodoFecha?: number; // Este campo solo se utiliza en el formulario. Deberá eliminarse antes del envío al BE
}

export class TwContenidoGesItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TwContenidoGesViewModel[];
}

export class TwContenidoGesViewModel {
    public Id?: number;
    public Titulo: string;
    public Subtitulo: string;
    public Descripcion: string;
    public DescripcionCorta: string;
    public FechaPublicacion?: Date;
    public IdTipoContenido: number;
    public IdUsuarioAutor: number;
    public EsPublico: boolean;
    public TwAdjuntoContenidoGesCollection?: TwAdjuntoContenidoGesViewModel[];
    public TwPerfilContenidoGesCollection?: TwPerfilContenidoGesViewModel[];
    public PerfilesAdmitidos: any;
}

export class TwAdjuntoContenidoGesViewModel {
    public Id: number;
    public IdContenido?: number;
    public NombreArchivo: string;
    public CodigoStorage: string;
    public FileSize: number;
    public TipoAdjunto: ETipoAdjunto;
    public FechaCreacion?: Date;
    public IdUsuario?: number;
    public MarkToDelete?: number;
    public IdDocFileSystem?: number;
}

export enum ETipoAdjunto {
    ImagenPequenia = 1,
    Imagen = 2,
    PDF = 3,
    Otro = 4,
}

export enum ETipoContenido {
    UltimasNoticias = 1,
    Aplicacion = 2,
    Avisos = 3,
    Campanias = 4,
}

export enum ETiposFechas {
    CUALQUIERA = 0,
    HOY = 1,
    SEMANA = 7,
    MES = 30,
    ANIO = 365,
    RANGO = 999,
}

export const OpcionesFechas: SelectItem[] = [
    { label: 'Cualquier fecha', value: ETiposFechas.CUALQUIERA },
    { label: 'Hoy', value: ETiposFechas.HOY },
    { label: 'Última semana', value: ETiposFechas.SEMANA },
    { label: 'Último mes', value: ETiposFechas.MES },
    { label: 'Último año', value: ETiposFechas.ANIO },
    { label: 'Intervalo personalizado...', value: ETiposFechas.RANGO },
];

export const OpcionesTiposContenido: SelectItem[] = [
    { label: 'Últimas Noticias', value: ETipoContenido.UltimasNoticias, icon: 'assets/images/Gestor/UltimasNoticias.png' },
    { label: 'Aplicación', value: ETipoContenido.Aplicacion, icon: 'assets/images/Gestor/Aplicacion.png' },
    { label: 'Avisos', value: ETipoContenido.Avisos, icon: 'assets/images/Gestor/Avisos.png' },
    { label: 'Campañas', value: ETipoContenido.Campanias, icon: 'assets/images/Gestor/Campanias.png' },
];

export class DatePickerSelection {
    public fechaInicio?: Date;
    public fechaFin?: Date;
}

export class TwPerfilContenidoGesViewModel {
    public Id?: number;
    public IdPerfil?: number;
    public IdContenidoGes?: number;
    public DescripcionPerfil: string;
    public MarkToDelete?: number;
}

export class FormControlContenidoGes {
    public Id?: number;
    public IdPerfil?: number;
    public IdContenidoGes?: number;
    public DescripcionPerfil: string;
    public Seleccionado: boolean;
}
